import styled from 'styled-components/macro';
import media from '../constants/MediaQuery';

const Emage = () => {
  return (
    <ES>
      <div className=" Emage__ES__es-container container">
        <div className="Emage__ES__es-container--dot-emage" style={{ backgroundImage: "url('/assets/images/dots.svg')" }} />
        <img className="Emage__ES__es-container--polsqa-emage emage" src="./assets/images/polsqa.png" alt="dotted-emage" />
      </div>
    </ES>
  );
};
const ES = styled.div`
  height: 409px;
  ${media.smallDesktopMin` height: 555px;`}
  .Emage__ES {
    &__es-container {

      padding: 80px 0;
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      height: 309px;
      ${media.smallDesktopMin` 
             height: 469px;
        `}
      .emage {
        width: 100%;
      }
      &--dot-emage {
        display: flex;
        justify-content: center;
        width: 100%;
        background-position: center;
        background-size: cover;
        height: 141px;

        ${media.tabletMin` width: 405px;`} 
        ${media.smallDesktopMin` 
              width: 446px;
              height: 294px;
        `}
      }
      &--polsqa-emage {
        display: block;
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        max-width: 374px;
        ${media.smallDesktopMin` 
              max-width:779px;
        `}
      }
    }
  }
`;

export default Emage;
